import React, { useState } from 'react';

function Signup() {
    // State variables for form data
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate the form fields
        if (!email || !username || !password || !confirmPassword) {
            setError('Please fill in all fields!');
            setSuccess(false);
            return;
        }

        if (password !== confirmPassword) {
            setError('Passwords do not match!');
            setSuccess(false);
            return;
        }

        // Simulate successful signup
        setError('');
        setSuccess(true); // Show the success message when the form is correctly filled

        // Optional: Reset form after submission (if you want)
        setEmail('');
        setUsername('');
        setPassword('');
        setConfirmPassword('');
    };

    return (
        <div style={styles.container}>
            <div style={styles.signupContainer}>
                <h2 style={styles.header}>Create an Account</h2>
                {error && <p style={styles.error}>{error}</p>}
                {success && <p style={styles.success}>Signup Successful! 🎉</p>}
                <form onSubmit={handleSubmit} style={styles.form}>
                    <label htmlFor="email" style={styles.label}>Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Enter your email"
                        style={styles.input}
                    />

                    <label htmlFor="username" style={styles.label}>Username:</label>
                    <input
                        type="text"
                        id="username"
                        name="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Enter a username"
                        style={styles.input}
                    />

                    <label htmlFor="password" style={styles.label}>Password:</label>
                    <input
                        type="password"
                        id="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        style={styles.input}
                    />

                    <label htmlFor="confirm-password" style={styles.label}>Confirm Password:</label>
                    <input
                        type="password"
                        id="confirm-password"
                        name="confirm-password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="Confirm your password"
                        style={styles.input}
                    />

                    <button type="submit" style={styles.button}>Sign Up</button>
                </form>
                <p style={styles.loginText}>Already have an account? <a href="/login" style={styles.link}>Login here</a></p>
            </div>
        </div>
    );
}

// Inline styles
const styles = {
    container: {
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f4f4f4',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
    },
    signupContainer: {
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
    },
    header: {
        textAlign: 'center',
        marginBottom: '20px',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        marginBottom: '5px',
    },
    input: {
        marginBottom: '15px',
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ddd',
        borderRadius: '5px',
    },
    button: {
        padding: '10px',
        fontSize: '16px',
        backgroundColor: '#4CAF50',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    },
    buttonHover: {
        backgroundColor: '#45a049',
    },
    loginText: {
        textAlign: 'center',
    },
    link: {
        color: '#4CAF50',
        textDecoration: 'none',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        marginBottom: '15px',
    },
    success: {
        color: 'green',
        textAlign: 'center',
        marginBottom: '15px',
    },
}

export default Signup;
